import { InformationDisplay } from "@/common/components/information-display/InformationDisplay"
import { removeExtraSpace } from "@/common/utilities/display-utilities";
import { Button } from "@chr/eds-react"
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { Box, Typography } from "@mui/material"
import { useState } from "react";

interface DimensionsProps {
  dimensionsStrings: string[];
}

export const Dimensions = ({dimensionsStrings}: DimensionsProps) => {
  const translate = useTranslation();
  const [expandedDims, setExpandedDims] = useState<boolean>(false);
return (
  <>
    <InformationDisplay
               data-testid={'dimensions-value'}
               label={translate('Dimensions')}
               textVariant={'subtitle2'}
               text={removeExtraSpace(dimensionsStrings[0], '-')}
             />
    {expandedDims && (
      dimensionsStrings.slice(1).map((dim, index) => (
        <Typography key={index} component="div" variant={'subtitle2'}>
          {dim}
        </Typography>
      ))
    )}
    {dimensionsStrings.length > 1 && (
            <Box sx={{ width: 150 }}>
              <Button
                startIcon={expandedDims ? 'expand_less' : 'expand_more'}
                onClick={() => setExpandedDims(prev => !prev)}
                variant={"tertiary"}
                buttonText={translate(
                  expandedDims ? 'View Less' : 'View All'
                )}
              />
            </Box>
          )}
  </>
);             
}
